<template>
  <div>
    <el-table
      v-bind:data="displaySymptomType"
      :show-header="false"
      row-key="id"
      @row-click="selectRow"
      :expand-row-keys="expand"
      empty-text="No symptoms recorded"
      style="width: 100%"
    >
      <!-- Expandable message history list -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <SymptomAnalysis
            v-bind:id="scope.row.id"
            v-bind:symptoms="scope.row.event"
          >
          </SymptomAnalysis>
        </template>
      </el-table-column>

      <el-table-column width="50">
        <template slot-scope="scope">
          <img
            v-if="symptomImage(scope.row.id)"
            class="symptom-icon"
            :src="symptomImage(scope.row.id)"
          />
          <img v-else class="symptom-icon" src="../image/symptom_default.png" />
        </template>
      </el-table-column>

      <el-table-column prop="title" width="250">
        <template slot-scope="scope">
          <div style="line-height:16px">
            <strong>{{ symptomTitle(scope.row.id) }}</strong>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="110">
        <template slot-scope="scope">
          <span class="times-count">{{
            formatCount(scope.row.event.length, "time")
          }}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column width="200">
			<template slot-scope="scope">
				{{ formatDateTime(scope.row.event.find((s) => s.id == patient.last_event['symptom:' + scope.row.id]).time) }}
			</template>
		</el-table-column> -->

      <el-table-column width="220">
        <template slot-scope="scope">
          <DateRange
            :row="scope.row"
            :patient="patient"
            :type="'symptom:' + scope.row.id"
          ></DateRange>
        </template>
      </el-table-column>

      <el-table-column>
        <template slot-scope="scope">
          <div>
            <!-- TODO: show related symptom information (activities that triggered it, insights, etc) -->
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="50">
        <template slot-scope="scope">
          <div style="margin-top: 10px;">
            <img
              v-if="expand.length && expand[0] === scope.row.id"
              src="../../images/up-arrow.png"
              width="21px"
              height="21px"
            />
            <img
              v-else
              src="../../images/down-arrow.png"
              width="21px"
              height="21px"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="show-more" v-if="showRows < symptomType.length">
      <el-button type="text" @click="showMore">
        {{ showMoreText }}&nbsp;<i class="el-icon-arrow-down"></i>
      </el-button>
    </div>
    <div
      class="show-more"
      v-if="showRows >= symptomType.length && this.showLess"
    >
      <el-button type="text" @click="showLessHandler">
        {{ showLessText }}&nbsp;<i class="el-icon-arrow-up"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import CardTable from "../component/table";
import { mapState, mapGetters, mapActions } from "vuex";

import SymptomGraph from "@/module/patient/graph/type/Symptom";
import SymptomAnalysis from "./analysis/Analysis";

export default {
  name: "patient-symptom-card-table",
  extends: CardTable,

  props: {
    patient: {
      type: Object,
      required: true,
    },
    symptoms: {
      type: Array,
    },
  },

  data() {
    return {
      showRows: 3,
      showLess: false,
    };
  },

  methods: {
    ...mapActions("content", ["loadContent"]),
    symptomImage(id) {
      return this.getContentKey("symptom", id, "image");
    },
    symptomTitle(id) {
      return this.getContentKey("symptom", id, "title");
    },
    selectRow(row, a, b) {
      if (this.expand[0] == row.id) this.expand = [];
      else this.expand = [row.id];
    },
    showMore() {
      this.showLess = true;
      this.showRows += 10;
    },
    showLessHandler() {
      this.showLess = false;
      this.showRows = 3;
    },
  },

  watch: {
    symptomIds(ids) {
      var missing = ids.filter((id) => !this.getContent("symptom", id));
      if (missing.length > 0) {
        this.loadContent({ type: "symptom", id: missing });
      }
    },
  },

  computed: {
    ...mapGetters("content", ["getContent", "getContentKey"]),
    symptomType() {
      return this.typeMap(this.symptoms);
    },
    displaySymptomType() {
      return this.symptomType.slice(0, this.showRows);
    },
    symptomIds() {
      return this.symptomType.map((type) => type.id);
    },
    schedule() {
      return this.getPatientSchedule(this.patient.id);
    },
    loading() {
      return this.getPatientLoadingState(this.patient.id);
    },
    showMoreText() {
      return "Show more";
    },
    showLessText() {
      return "Show less";
    },
  },

  components: {
    SymptomGraph,
    SymptomAnalysis,
  },
};
</script>

<style lang="scss" scoped>
.show-more {
  .el-button, .el-button:hover, .el-button:focus {
    display: block;
    width: 100%;
    font-size: 14px;
    color: #4a9bf9;
    font-weight: 600;
  }
  .el-icon-arrow-down {
    font-weight: 700;
  }
}

.symptom-icon {
  float: left;
  width: 32px;
  height: 32px;
}

.times-count {
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #333333;
}
</style>
